module.exports = __webpack_public_path__ + "img/swkn.4a186bf0.jpg";